<template>
  <div>
    <a
      href="#"
      class="btn btn-primary float-right half-gutter-bottom"
      v-on:click.prevent="openAddModal"
      >Add User</a
    >
    <table class="table table-bordered">
      <thead>
        <tr>
          <th>Name</th>
          <th>Email Address</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-bind:key="key" v-for="(user, key) in users">
          <td>{{ user.first_name }} {{ user.last_name }}</td>
          <td>{{ user.email }}</td>
          <td>
            <button
              class="btn btn-warning"
              v-on:click.prevent="openEditModal(key)"
            >
              Edit
            </button>
            <button class="btn btn-danger" v-on:click.prevent="removeUser(key)">
              Delete
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <modal :show="modals.add" :large="true" v-on:close="closeAddModal">
      <div slot="title">
        <h4>Add User</h4>
      </div>
      <div class="row">
        <div class="col-xl-12">
          <div class="form-horizontal">
            <inputbox
              name="first_name"
              label="First Name"
              :required="true"
              v-model="add.first_name"
              :show-error="add.errors.has('first_name')"
              :error-message="add.errors.get('first_name')"
            ></inputbox>

            <inputbox
              name="last_name"
              label="Last Name"
              :required="true"
              v-model="add.last_name"
              :show-error="add.errors.has('last_name')"
              :error-message="add.errors.get('last_name')"
            ></inputbox>

            <inputbox
              name="email"
              label="Email Address"
              type="email"
              :required="true"
              v-model="add.email"
              :show-error="add.errors.has('email')"
              :error-message="add.errors.get('email')"
            ></inputbox>

            <inputbox
              name="password"
              label="Password"
              type="password"
              :required="true"
              v-model="add.password"
              :show-error="add.errors.has('password')"
              :error-message="add.errors.get('password')"
            ></inputbox>

            <selectlist
              name="role"
              label="Role"
              v-model="add.role"
              :options="roles"
              placeholder="Please Select"
            ></selectlist>
          </div>
        </div>
      </div>
      <div slot="footer">
        <button
          class="btn btn-danger float-left"
          v-on:click.prevent="closeAddModal"
        >
          Close
        </button>
        <button class="btn btn-primary" v-on:click.prevent="addUser">
          Add User
        </button>
      </div>
    </modal>

    <modal :show="modals.edit" :large="true" v-on:close="closeEditModal">
      <div slot="title">
        <h4>
          Edit User: <span>{{ edit.first_name }} {{ edit.last_name }}</span>
        </h4>
      </div>
      <div class="row">
        <div class="col-xl-12">
          <div class="form-horizontal">
            <inputbox
              name="first_name"
              label="First Name"
              :required="true"
              v-model="edit.first_name"
              :show-error="edit.errors.has('first_name')"
              :error-message="edit.errors.get('first_name')"
            ></inputbox>

            <inputbox
              name="last_name"
              label="Last Name"
              :required="true"
              v-model="edit.last_name"
              :show-error="edit.errors.has('last_name')"
              :error-message="edit.errors.get('last_name')"
            ></inputbox>

            <inputbox
              name="email"
              label="Email Address"
              type="email"
              :required="true"
              v-model="edit.email"
              :show-error="edit.errors.has('email')"
              :error-message="edit.errors.get('email')"
            ></inputbox>

            <selectlist
              name="role"
              label="Role"
              v-model="edit.role"
              :options="roles"
              placeholder="Please Select"
            ></selectlist>
          </div>
        </div>
      </div>
      <div slot="footer">
        <button
          class="btn btn-danger float-left"
          v-on:click.prevent="closeEditModal"
        >
          Close
        </button>
        <button class="btn btn-primary" v-on:click.prevent="updateUser">
          Update User
        </button>
      </div>
    </modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      users: [],
      modals: {
        add: false,
        edit: false
      },
      add: new window.Form({
        first_name: null,
        last_name: null,
        email: null,
        password: null,
        role: ''
      }),
      edit: new window.Form({
        first_name: null,
        last_name: null,
        email: null,
        role: ''
      }),
      editingIndex: null
    };
  },

  computed: {
    roles() {
      return this.$store.getters['Roles/all'];
    }
  },

  mounted() {
    this.getAllUsers();
  },

  methods: {
    removeUser(key) {
      window
        .swal({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete the user!'
        })
        .then(() => {
          let user = this.users[key];

          window.Ajax.delete(
            `/agents/${this.$route.params.identifier}/users/${user.identifier}`
          )
            .then(response => {
              window.swal(
                'Deleted!',
                'The user was deleted successfully!',
                'success'
              );
              this.users.splice(key, 1);
            })
            .catch(err => {
              window.toastify.error(
                'Error',
                'Sorry, there was an issue deleting the user.'
              );
            })
            .catch(() => {});
        });
    },

    getAllUsers() {
      window.Ajax.get(`/agents/${this.$route.params.identifier}/users`)
        .then(response => {
          this.users = response.data;
        })
        .catch(error => {});
    },

    addUser() {
      this.add
        .post(`/agents/${this.$route.params.identifier}/users`)
        .then(response => {
          this.users.push(response);
          this.closeAddModal();
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            'Sorry, there was an issue saving the user'
          );
        });
    },

    updateUser() {
      this.edit
        .put(
          `/agents/${this.$route.params.identifier}/users/${
            this.users[this.editingIndex].identifier
          }`
        )
        .then(response => {
          this.users[this.editingIndex] = response;
          this.closeEditModal();
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            'Sorry, there was an issue saving the user'
          );
        });
    },

    openAddModal() {
      this.modals.add = true;
    },

    closeAddModal() {
      this.modals.add = false;
      this.add.first_name = null;
      this.add.last_name = null;
      this.add.email = null;
      this.add.password = null;
      this.add.role = '';
    },

    closeEditModal() {
      this.modals.edit = false;
      this.edit.first_name = null;
      this.edit.last_name = null;
      this.edit.email = null;
      this.edit.role = '';
      this.editingIndex = null;
    },

    openEditModal(key) {
      this.editingIndex = key;

      this.edit.first_name = this.users[key].first_name;
      this.edit.last_name = this.users[key].last_name;
      this.edit.email = this.users[key].email;
      this.edit.role = this.users[key].role_id;
      this.modals.edit = true;
    }
  }
};
</script>
